





























































































import Component from 'vue-class-component';
import {Emit, Prop, Watch} from 'vue-property-decorator';
import {AgentOfficeCriteria} from '../../../components/criteria/agent-office-criteria';
import sitesApi from '@/api/sites.api';
import {formatDate, createBigPeriodListItems} from '@/utils';
import {
    IDictionary,
    IFormControl,
    IGetLoginLogs,
    ICompany,
    IListItem,
    ICriterion,
    DateRangeMapper,
    ISite, getOptionListAccountRoles
} from '../../../entities';
import * as types from '../../../store/types';
import {mapGetters} from 'vuex';

@Component({
    computed: mapGetters({
        companyPermissions: types.AUTH_HAS_COMPANY_PERMISSIONS,
        adminPermissions: types.AUTH_HAS_ADMIN_PERMISSIONS
    })
})
export default class CommonLogsCriteriaComponent extends AgentOfficeCriteria {

    public dateRangeHints: IListItem[] = [
        {heading: 'Choose payout period', value: null},
        ...createBigPeriodListItems()
    ];

    public formState: IDictionary<IFormControl> = this.createFormState();

    public roles: IListItem[] = getOptionListAccountRoles();

    protected onlyAvailableCompanies = false;

    public created() {
        super.created();
        this.doSearch();
    }

    public createFormState(): IDictionary<IFormControl> {
        const defValues = this.defaultFormValues();
        return {
            role: {
                key: 'role',
                label: 'Role',
                value: null
            },
            username: {
                key: 'username',
                label: 'Auth User',
                value: null
            },
            ip: {
                key: 'ip',
                label: 'IP Address',
                value: ''
            },
            companyId: {
                key: 'companyId',
                label: 'Office',
                value: null
            },
            agentId: {
                key: 'agentId',
                label: 'Agent',
                value: null
            },
            accountId: {
                key: 'accountId',
                label: 'accountId - not use',
                value: null
            },
            actionType: {
                key: 'actionType',
                label: 'Action Type',
                value: ''
            },
            actionPath: {
                key: 'actionName',
                label: 'Action Path',
                value: ''
            },
            responseCode: {
                key: 'responseCode',
                label: 'Response Code',
                value: ''
            },
            postParams: {
                key: 'postParams',
                label: 'Post Params (Very High Load)',
                value: ''
            },
            dateRange: {
                key: 'dateRange',
                label: 'Date',
                value: this.getDefaultDateRange(),
                mapper: DateRangeMapper
            }
        };
    }

    public defaultFormValues(): IDictionary<any> {
        return {
            role: null,
            username: null,
            ip: '',
            companyId: null,
            agentId: null,
            accountId: null,
            actionType: '',
            actionName: '',
            responseCode: '',
            postParams: '',
            dateRange: this.getDefaultDateRange()
        };
    }

    public getQueryObject(formState: IDictionary<IFormControl>) {
        return {
            role: formState.role.value,
            username: formState.username.value,
            ip: formState.ip.value ? formState.ip.value.trim() : null,
            companyId: formState.companyId.value,
            agentId: formState.agentId.value,
            accountId: formState.accountId.value,
            actionType: formState.actionType.value,
            actionName: formState.actionPath.value,
            responseCode: formState.responseCode.value,
            postParams: formState.postParams.value,
            start: formatDate(formState.dateRange.value.start),
            end: formatDate(formState.dateRange.value.end)
        };
    }

    @Emit()
    public search(body) {
        this.saveDateRange({
            start: body.start,
            end: body.end
        });
    }

    @Emit()
    public download(body) {
        console.log('download emit base method');
    }

    @Watch('formState.companyId.value')
    private onCompanyIdChanged(val: string, oldVal: string) {
        this._reloadAgents(this.formState.companyId.value);
    }

    @Watch('$route')
    private onRouteChanged(val: string, oldVal: string) {
        this.doSearch();
    }
}
